export { default } from './ShoppingCartOOSProducts';
